// extracted by mini-css-extract-plugin
export default {"component":"SignIn__component-JGNf","subTitle":"SignIn__subTitle-JDSp","buttons":"SignIn__buttons-wKdz","loading":"SignIn__loading-J4i6"};